module.exports = __webpack_public_path__ + "img/laboratorio3_4-3.5dc7045f.webp";